import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ErrorBox, useFetch, useToast } from '@vertesia/ui/core';
import { useUserSession } from '@vertesia/ui/session';
import { useUITranslation } from '../../../../i18n/index.js';
import { useDocumentSelection } from '../DocumentSelectionProvider';
import { useDocumentSearch } from '../search/DocumentSearchContext';
import { AddToCollectionAction } from './actions/AddToCollectionAction';
import { ChangeTypeAction } from './actions/ChangeTypeAction';
import { DeleteObjectsAction, DeleteObjectsFromCollectionsAction } from './actions/DeleteObjectsAction';
import { ExportPropertiesAction } from './actions/ExportPropertiesAction';
import { RemoveFromCollectionAction } from './actions/RemoveFromCollectionAction';
import { StartWorkflowAction, StartWorkflowComponent } from './actions/StartWorkflowComponent';
import { ObjectsActionContext } from './ObjectsActionContextClass';
import { ObjectsActionContextReact, useObjectsActionContext } from './ObjectsActionHooks';
const DEFAULT_ACTIONS = [
    ExportPropertiesAction,
    ChangeTypeAction,
    StartWorkflowAction,
    AddToCollectionAction,
    DeleteObjectsAction,
    RemoveFromCollectionAction,
    DeleteObjectsFromCollectionsAction,
];
export function ObjectsActionContextProvider({ children, type }) {
    const { t } = useUITranslation();
    const selection = useDocumentSelection();
    const toast = useToast();
    const { client } = useUserSession();
    const search = useDocumentSearch();
    const { data: rules, error } = useFetch(() => {
        return client.workflows.rules.list().then((rules) => {
            return rules.map(rule => ({
                id: rule.id,
                name: rule.name,
                description: rule.description,
                confirm: false,
                isWorkflow: true,
                component: StartWorkflowComponent
            })).sort((a, b) => a.name.localeCompare(b.name));
        });
    }, []);
    const context = useMemo(() => {
        const context = new ObjectsActionContext({
            selection, toast, client, search, type
        });
        context.allActions = DEFAULT_ACTIONS;
        context.wfRules = rules;
        return context;
    }, [selection, rules, type]);
    if (error) {
        return _jsx(ErrorBox, { title: t('store.failedToFetchWorkflows'), children: error.message });
    }
    return (context && (_jsxs(ObjectsActionContextReact.Provider, { value: context, children: [_jsx(Actions, {}), children] })));
}
function Actions() {
    const context = useObjectsActionContext();
    const selection = context.params.selection;
    const objectId = selection.getObjectId();
    const objectIds = selection.isSingleSelection() && objectId ? [objectId] : selection.getObjectIds();
    return (_jsx("div", { style: { display: 'none' }, children: context.allActions.map(action => (_jsx(action.component, { action: action, objectIds: objectIds, collectionId: selection.collectionId }, action.id))) }));
}
//# sourceMappingURL=ObjectsActionContext.js.map